// extracted by mini-css-extract-plugin
export default {"placeholder":"search-client-js-components-___SearchBar-module__placeholder___aEK57","label":"search-client-js-components-___SearchBar-module__label___TkNsV"};